import { render } from "./facebook.vue?vue&type=template&id=120f5fb7"
import script from "./facebook.vue?vue&type=script&lang=js"
export * from "./facebook.vue?vue&type=script&lang=js"

import "./facebook.vue?vue&type=style&index=0&id=120f5fb7&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/global/videos/_components/facebook.vue'],['render',render],['__file',"facebook.vue"]])

export default __exports__